 <section [id]="modalId" class="opacity-0"> <!-- to make sure no flash/flicker is visible -->
  <div class="modal-header">
    <div class="image-title-container">
      <svg    width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#F2F2F2"/><path d="M17.181 9.004h-4.24L6.618 19.779H3.5V23h4.957l5.188-8.846v8.843h4.174l5.163-8.87v8.87h3.548V9h-4.254l-5.095 8.68V9.004z" fill="#000"/></svg>
      <h3 class="modal-title" i18n>Live Chat</h3>
    </div>
    <div class="close-modal" (click)="closeModal()">
      <svg   width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.868 4.575l.707-.707 7.778 7.778 7.425-7.424.707.707-7.424 7.424 7.07 7.071-.707.708-7.07-7.072-7.425 7.425-.707-.707 7.424-7.425-7.778-7.778z" fill="#757575"/></svg>
    </div>
  </div>
  <div class="modal-body">
    <p class="unavailable-message" i18n>Live Chat is not available right now.</p>
  </div>
</section>
